import {useContext, useState} from 'react'
import useApi from '../../../services/useApi'
import {TicketDetailsContext} from '../context'

function useCommentOperations() {
  const Api = useApi()
  const {ticketId} = useContext(TicketDetailsContext)
  const [isLoading, setLoading] = useState(false)
  const refetchAPIs = [`${ticketId}-comments-list`, `${ticketId}-activities-history`]

  async function createComment(payload: any) {
    return Api.post(`/agile/projects/cards/${ticketId}/comments`, payload, {
      setLoading: setLoading,
      successMessage: 'Comment added successfully',
      refetch: refetchAPIs,
    })
  }

  async function editComment(commentId: any, payload: any) {
    return Api.put(`/agile/projects/cards/${ticketId}/comments/${commentId}`, payload, {
      setLoading: setLoading,
      successMessage: 'Comment updated successfully',
      refetch: refetchAPIs,
    })
  }

  async function deleteComment(commentId: any) {
    return Api.delete(
      `/agile/projects/cards/${ticketId}/comments/${commentId}`,
      {},
      {
        setLoading: setLoading,
        successMessage: 'Comment deleted successfully',
        refetch: refetchAPIs,
      }
    )
  }
  return {
    createComment,
    editComment,
    deleteComment,
    isLoading,
  }
}

export default useCommentOperations
